import http from "./httpService";
import urlConstant from "../constants/url-constants";

export async function getUserServiceRequestItems(userId, serial) {
    return http.post(urlConstant.getVisitHistoryEndpoint(), { userId: userId, serial: serial }, http.getAuthorizedConfig());
}

export default {
    getUserServiceRequestItems
};